



























































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import moment from 'moment'
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import Footer from '@/components/Footer.vue'
import { Milk } from '@/interfaces/Milk'
import axios from 'axios'
import DexieService from '@/services/dexie-service'
import ApiService from '@/services/api-service'
import AuthService from '@/services/auth-service'
import SnackbarService from './services/snackbar-service'
import { Sync } from '@/interfaces/Sync'

@Component({
  components: {
    NavigationDrawer,
    Footer,
  },
})
export default class App extends Mixins(
  DexieService,
  ApiService,
  SnackbarService,
  AuthService
) {
  axios: any
  moment: any

  syncingData = false

  pleaseSyncDialogIsOpen = false

  overdueMessageClosed = false

  created() {
    moment.locale('es')
    this.axios = axios
    this.moment = moment
    const token = localStorage.getItem('accessToken')
    if (token) {
      this.$store.state.token = token
    }

    this.getAllCowsUpdateCache()
    //this.getMilks()
    this.updateOnlineStatusAndSyncs()
    this.updateShowSyncMessage()
    document.addEventListener('click', this.updateOnlineStatusAndSyncs)
  }

  getMilks() {
    this.$store.state.loading = true
    axios
      .get(`/milks`)
      .then((res: any) => {
        const milks = res.data[0].milks
        milks.forEach((milk: Milk) => {
          milk.day = moment.utc(milk.day).format('YYYY-MM-DD')
          milk.priceLiter = milk.price * milk.liter
        })
        this.$db.milks.clear().then(() => {
          this.$db.milks.bulkPut(milks)
        })
      })
      .catch(error => {
        if (
          error.response &&
          error.response.status !== 401 &&
          error.response.status >= 300
        ) {
          this.notify({ text: `Server error. ${error}` })
        }
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  updateOnlineStatusAndSyncs() {
    if (navigator.onLine) {
      this.$store.state.online = true
      if (!this.syncingData && !this.$store.state.userDeniedSync) {
        this.$db.syncs.count().then((count: number) => {
          if (count > 0) {
            this.pleaseSyncDialogIsOpen = true
          }
        })
      }
    } else {
      this.$store.state.online = false
    }

    // give dexie db some time to finish save, then update sync length
    setTimeout(() => {
      this.updateSyncLength()
    }, 1500)
  }

  saveUserDeniedSync() {
    this.$store.state.userDeniedSync = true
    this.pleaseSyncDialogIsOpen = false
  }

  async syncData() {
    if (navigator.onLine) {
      this.syncingData = true
      this.$store.state.loading = true
      this.pleaseSyncDialogIsOpen = false
      const syncs: Sync[] = await this.$db.syncs.toArray()
      syncs.forEach((sync: Sync) => {
        sync.synced = false
        sync.syncError = false
      })
      const syncLength = syncs.length
      let counter = 1
      let syncErrorLength = 0
      for await (const sync of syncs) {
        this.$store.state.loadingMessage = `Syncing ${counter}/${syncLength}`
        try {
          await this.axios({
            method: sync.method,
            url: sync.url,
            data: sync.payload,
          })
          this.$db.syncs.delete(sync.id)
        } catch (error) {
          let errorMessage
          if (error.response.data && error.response.data.detail) {
            errorMessage = error.response.data && error.response.data.detail
          } else {
            errorMessage = error
          }
          sync.syncing = false
          sync.synced = false
          sync.syncError = true
          sync.errorMessage = errorMessage
          syncErrorLength += 1
          this.$db.syncs.update(sync.id, sync)
        }
        counter += 1
      }
      this.updateSyncLength()
      this.$store.state.loading = false
      this.$store.state.loadingMessage = ''
      if (syncErrorLength > 0) {
        this.notify({
          text: `Error syncronzar datos. ${syncErrorLength} Syncs failed`,
        })
      } else {
        this.notify({ text: 'Datos up to date', type: 'success' })
      }
      this.syncingData = false
    } else {
      this.notify({ text: 'No connection de internet' })
    }
  }

  get colorNavbar() {
    if (['cows', 'cow-details'].includes(this.$route.name)) {
      return this.$store.state.account
        ? `color-${this.$store.state.account.farms
            .map(f => f.id)
            .indexOf(this.$store.state.selectedFarmId)}`
        : null
    } else {
      return null
    }
  }

  @Watch('$store.state.openSyncs')
  @Watch('$store.state.online')
  updateShowSyncMessage() {
    const id = 'PERMANENT_INFO_SYNCS'
    console.log(this.$store.state.openSyncs)
    console.log(this.$store.state.online)
    if (
      !this.$store.state.loading &&
      this.$store.state.online &&
      this.$store.state.openSyncs > 0
    ) {
      console.log('show open syncs message')
      this.notifyPermanent(
        {
          text:
            'You have open syncs. Please sync your data to garantee data consistency',
          type: 'info',
        },
        id
      )
    } else {
      this.unNotifyPermanent(id)
    }
  }
}
